export default {"src":"/_next/static/media/clap-theme-icon.2f05eee6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};